module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei4.svg";